/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import swal from 'sweetalert2';
import TextLine from '../../components/common/TextLine';
import TextBox from '../../components/common/TextBox';
import Dropdown from '../../components/common/Dropdown';
import Loading from '../../components/common/Loading';

const Container = styled.div`
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  height: 94vh;
  overflow-y: auto;
  width: 100%;
  margin: 16px 16px 16px 0;
  padding: 28px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.04), 0 4px 20px rgba(0, 0, 0, 0.06);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

const Title = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: #1d1d1f;
  margin: 0;
`;

const BtnGroup = styled.div`
  display: flex;
  gap: 8px;
`;

const Btn = styled.button`
  padding: 9px 22px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  background: ${({ $variant }) =>
    $variant === 'primary' ? '#007aff' :
    $variant === 'danger' ? '#fef2f2' : '#f3f4f6'};
  color: ${({ $variant }) =>
    $variant === 'primary' ? '#fff' :
    $variant === 'danger' ? '#dc2626' : '#374151'};
  &:hover {
    background: ${({ $variant }) =>
      $variant === 'primary' ? '#0066d6' :
      $variant === 'danger' ? '#fee2e2' : '#e5e7eb'};
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 280px 1fr 1fr;
  gap: 20px;
  margin-bottom: 24px;
`;

const Card = styled.div`
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 20px;
`;

const CardTitle = styled.h4`
  font-size: 15px;
  font-weight: 700;
  color: #1d1d1f;
  margin: 0 0 16px 0;
`;

const ThumbnailWrap = styled.label`
  position: relative;
  display: block;
  width: 100%;
  height: 240px;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  &:hover > div { opacity: 1; }
`;

const ThumbnailOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #f5f5f7;
  border-radius: 12px;
`;

const PriceRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
`;

const PriceLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #6e6e73;
  width: 65px;
  text-transform: uppercase;
`;

const Won = styled.span`
  font-size: 14px;
  color: #86868b;
`;

const FieldLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #6e6e73;
  margin-bottom: 4px;
  margin-top: 12px;
  &:first-child { margin-top: 0; }
`;

const SectionTitle = styled.h3`
  font-size: 17px;
  font-weight: 700;
  color: #1d1d1f;
  margin: 0 0 12px 0;
`;

const OrderTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  th, td {
    padding: 10px 12px;
    font-size: 13px;
    border-bottom: 1px solid #f3f4f6;
    text-align: left;
  }
  thead tr { background: #2d3748; }
  th { font-weight: 600; color: #fff; font-size: 12px; }
  td { color: #1d1d1f; }
  tbody tr { transition: background 0.1s; }
  tbody tr:hover { background: rgba(0,122,255,0.04); }
`;

const PageBtn = styled.button`
  padding: 5px 12px;
  border: 1px solid #d2d2d7;
  border-radius: 6px;
  background: ${({ $active }) => $active ? '#007aff' : '#fff'};
  color: ${({ $active }) => $active ? '#fff' : '#374151'};
  font-size: 13px;
  cursor: pointer;
  &:hover { background: ${({ $active }) => $active ? '#0066d6' : '#f3f4f6'}; }
  &:disabled { opacity: 0.4; cursor: default; }
`;

const formatTime = (t) => {
  if (!t) return '-';
  const m = t.match(/(\d{4})\.(\d{2})\.(\d{2})/);
  return m ? `${m[1].slice(2)}/${m[2]}/${m[3]}` : t;
};

const ProductDetailPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [product, setProduct] = useState();
  const [manufacturer, setManufacturer] = useState([]);
  const [category, setCategory] = useState([]);
  const [url, setUrl] = useState();
  const [file, setFile] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [orderPage, setOrderPage] = useState(1);
  const [orderTotal, setOrderTotal] = useState(0);
  const [orderTotalPages, setOrderTotalPages] = useState(0);

  const _handleChange = (e) => {
    let { value, name } = e.target;
    if (!(name === 'product_name' || name === 'description'))
      value = value.replace(/[^0-9]/g, '');
    setProduct({ ...product, [name]: value });
  };

  const _selectChange = (name, value) => {
    if (name === 'main_category') getCategory(value);
    setProduct({ ...product, [name]: value });
  };

  const getProduct = async (pid) => {
    try {
      setIsLoading(true);
      const { data } = await axios.get(`/admin/products/productlist/${pid}`);
      setProduct(data);
      setUrl(data.img);
      getManufacturer();
      getCategory(data.main_category);
      fetchOrders(data.product_name, 1);
      setIsLoading(false);
    } catch (e) { console.log(e); }
  };

  const getManufacturer = async () => {
    try {
      const { data } = await axios.get('/admin/manufacturer');
      setManufacturer(data.map((d) => d.main_category));
    } catch (e) { console.log(e); }
  };

  const getCategory = async (mfr) => {
    try {
      const { data } = await axios.get(`/admin/category/${mfr}`);
      setCategory(data.map((d) => d.sub_category));
    } catch (e) { console.log(e); }
  };

  const _uploadImage = (e) => {
    const imgFile = e.target.files[0];
    setUrl(URL.createObjectURL(imgFile));
    setFile(imgFile);
  };

  const fetchOrders = async (productName, page) => {
    try {
      const { data } = await axios.get(
        `/admin/users/product-orders/${encodeURIComponent(productName)}?page=${page}&size=5`
      );
      setOrders(data.orders);
      setOrderTotal(data.total);
      setOrderTotalPages(data.totalPages);
      setOrderPage(page);
    } catch (e) { console.log(e); }
  };

  const updateProduct = async () => {
    try {
      if (file) {
        const formData = new FormData();
        formData.append('image', file);
        await axios.post(`/admin/products/image/${id}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
      }
      const res = await axios.put(`/admin/products/update/${id}`, product);
      if (res.status === 200)
        swal.fire({ text: '저장되었습니다.', icon: 'success', showConfirmButton: false, timer: 1000 });
    } catch {
      swal.fire({ text: '오류가 발생했습니다.', icon: 'error', showConfirmButton: false, timer: 1000 });
    }
  };

  const deleteProduct = async () => {
    const s1 = await swal.fire({
      text: '이 제품을 삭제하시겠습니까?', icon: 'warning', iconColor: '#dc2626',
      showCancelButton: true, confirmButtonColor: '#dc2626', cancelButtonColor: '#a3a3a3',
      confirmButtonText: '삭제', cancelButtonText: '취소',
    });
    if (!s1.isConfirmed) return;
    const s2 = await swal.fire({
      text: '정말 삭제하시겠습니까? 휴지통에서 복원할 수 있습니다.', icon: 'warning', iconColor: '#dc2626',
      showCancelButton: true, confirmButtonColor: '#dc2626', cancelButtonColor: '#a3a3a3',
      confirmButtonText: '삭제 확인', cancelButtonText: '취소',
    });
    if (!s2.isConfirmed) return;
    try {
      await axios.patch(`/admin/trash/delete/product/${id}`);
      swal.fire({ text: '삭제되었습니다.', icon: 'success', showConfirmButton: false, timer: 1000 });
      navigate('/product/list');
    } catch {
      swal.fire({ text: '오류가 발생했습니다.', icon: 'error', showConfirmButton: false, timer: 1000 });
    }
  };

  useEffect(() => { getProduct(id); }, [id]);

  const priceFields = [
    { key: 'level1', label: 'Level 1' },
    { key: 'level2', label: 'Level 2' },
    { key: 'level3', label: 'Level 3' },
    { key: 'school', label: 'School' },
    { key: 'mall', label: 'Mall' },
    { key: 'vip', label: 'VIP' },
  ];

  return (
    <div style={{ width: '100%' }}>
      {product && (
        <Container>
          <Header>
            <div>
              <Title>{product.product_name}</Title>
              <span style={{ fontSize: 13, color: '#86868b' }}>
                {product.main_category} &gt; {product.sub_category}
              </span>
            </div>
            <BtnGroup>
              <Btn onClick={() => navigate('/product/list')}>목록</Btn>
              <Btn $variant="danger" onClick={deleteProduct}>삭제</Btn>
              <Btn $variant="primary" onClick={updateProduct}>저장</Btn>
            </BtnGroup>
          </Header>

          <Grid>
            {/* 썸네일 */}
            <Card>
              <CardTitle>썸네일</CardTitle>
              <ThumbnailWrap htmlFor="input-file">
                <ThumbnailOverlay>클릭하여 변경</ThumbnailOverlay>
                <Image src={url} />
              </ThumbnailWrap>
              <input id="input-file" type="file" accept="image/*" onChange={_uploadImage} style={{ display: 'none' }} />
            </Card>

            {/* 가격 */}
            <Card>
              <CardTitle>가격 정보</CardTitle>
              {priceFields.map((f) => (
                <PriceRow key={f.key}>
                  <PriceLabel>{f.label}</PriceLabel>
                  <div style={{ flex: 1 }}>
                    <TextLine value={product[f.key]} name={f.key} onChange={_handleChange} />
                  </div>
                  <Won>&#8361;</Won>
                </PriceRow>
              ))}
            </Card>

            {/* 제품 정보 */}
            <Card>
              <CardTitle>제품 정보</CardTitle>
              <FieldLabel>제조사</FieldLabel>
              <Dropdown value={product.main_category} name="main_category" data={manufacturer} _selectChange={_selectChange} />
              <FieldLabel>카테고리</FieldLabel>
              <Dropdown value={product.sub_category} name="sub_category" data={category} _selectChange={_selectChange} />
              <FieldLabel>제품명</FieldLabel>
              <TextBox height={60} value={product.product_name} name="product_name" onChange={_handleChange} />
            </Card>
          </Grid>

          {/* 상세 설명 */}
          <Card style={{ marginBottom: 24 }}>
            <CardTitle>상세 설명</CardTitle>
            <TextBox height={120} value={product.description} name="description" onChange={_handleChange} />
          </Card>

          {/* 관련 주문 */}
          <Card>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
              <SectionTitle style={{ margin: 0 }}>관련 주문</SectionTitle>
              <span style={{ fontSize: 13, color: '#86868b' }}>총 {orderTotal}건</span>
            </div>
            {orders.length > 0 ? (
              <>
                <OrderTable>
                  <thead>
                    <tr>
                      <th>발주번호</th>
                      <th>회사</th>
                      <th>발주일</th>
                      <th>수량</th>
                      <th style={{ textAlign: 'right' }}>금액</th>
                      <th>상태</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.map((o) => {
                      const item = o.items?.find((i) => i.product_name === product.product_name);
                      const shipped = o.postNum && o.postNum !== '발주 확인 중';
                      return (
                        <tr key={o._id}>
                          <td style={{ fontFamily: "'SF Mono', monospace", fontSize: 12 }}>{o.order_id}</td>
                          <td style={{ fontWeight: 600 }}>{o.company_name}</td>
                          <td>{formatTime(o.time)}</td>
                          <td>{item ? item.count : '-'}</td>
                          <td style={{ textAlign: 'right', fontFamily: "'SF Mono', monospace" }}>
                            {item ? (item.count * item.unit_price).toLocaleString('ko-KR') : '-'}
                          </td>
                          <td>
                            <span style={{
                              padding: '2px 8px', borderRadius: 10, fontSize: 12, fontWeight: 600,
                              background: shipped ? '#ecfdf5' : '#fef3c7',
                              color: shipped ? '#065f46' : '#92400e',
                            }}>
                              {shipped ? '출고완료' : '확인중'}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </OrderTable>
                {orderTotalPages > 1 && (
                  <div style={{ display: 'flex', gap: 4, justifyContent: 'center', marginTop: 12 }}>
                    <PageBtn disabled={orderPage <= 1} onClick={() => fetchOrders(product.product_name, orderPage - 1)}>이전</PageBtn>
                    <span style={{ fontSize: 13, color: '#86868b', lineHeight: '30px', margin: '0 8px' }}>
                      {orderPage} / {orderTotalPages}
                    </span>
                    <PageBtn disabled={orderPage >= orderTotalPages} onClick={() => fetchOrders(product.product_name, orderPage + 1)}>다음</PageBtn>
                  </div>
                )}
              </>
            ) : (
              <div style={{ color: '#86868b', fontSize: 14, textAlign: 'center', padding: '24px 0' }}>
                관련 주문이 없습니다.
              </div>
            )}
          </Card>
        </Container>
      )}
      {isLoading && <Loading />}
    </div>
  );
};

export default ProductDetailPage;
